import React from 'react';
import { Col, Modal, Row } from 'react-bootstrap';

const ProfileEngagementFrequencyModal = (props) => {
  const { project, show, onHide, status } = props;
  const { stakeholderFields } = project;
  const engagementFrequencyName = stakeholderFields.find(
    (field) => field.nativeColumn === 'engagement_frequency'
  ).name;

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontWeight: 400 }}>
          {engagementFrequencyName}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="m-b-16">
          <Col
            xs={12}
            className={`${status === 'Very Often' ? '' : 'text-muted'} modal-key-label m-b-16`}
          >
            <span
              style={{ marginRight: '8px' }}
              className="sentiment-dot sentiment-dot-sm sentiment-dot-very-often"
            />
            <span>Very Often</span>
          </Col>
          <Col
            xs={12}
            className={`${status === 'Often' ? '' : 'text-muted'} modal-key-label m-b-16`}
          >
            <span
              style={{ marginRight: '8px' }}
              className="sentiment-dot sentiment-dot-sm sentiment-dot-often"
            />
            <span>Often</span>
          </Col>
          <Col
            xs={12}
            className={`${status === 'Sometimes' ? '' : 'text-muted'} modal-key-label m-b-16`}
          >
            <span
              style={{ marginRight: '8px' }}
              className="sentiment-dot sentiment-dot-sm sentiment-dot-sometimes"
            />
            <span>Sometimes</span>
          </Col>
          <Col
            xs={12}
            className={`${status === 'Rarely' ? '' : 'text-muted'} modal-key-label m-b-16`}
          >
            <span
              style={{ marginRight: '8px' }}
              className="sentiment-dot sentiment-dot-sm sentiment-dot-rarely"
            />
            <span>Rarely</span>
          </Col>
          <Col
            xs={12}
            className={`${status === 'Very Rarely' ? '' : 'text-muted'} modal-key-label`}
          >
            <span
              style={{ marginRight: '8px' }}
              className="sentiment-dot sentiment-dot-sm sentiment-dot-very-rarely"
            />
            <span>Very Rarely</span>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
};

export default ProfileEngagementFrequencyModal;
